module.exports = __webpack_public_path__ + "img/ProgressiveJackpot_2208x1242_8.d75867e8.png";